// #tag: NAVIGATION ITEMS ADAPTER HOOK
// #purpose: Transforms raw CMS navigation records into formatted NavItem objects with resolved icons and role-based route adaptations.
import { useMemo } from 'react';
import { resolveIcon } from '../lib/iconMap';
import { useAuth } from '../context/AuthProvider';
import { useNavigation } from './useExamData';
import type { NavItem } from '../config/navigation';

export function useNavItems(): { items: NavItem[]; isLoading: boolean } {
  const { data, isLoading } = useNavigation('primary');
  const { isSignedIn, isAdmin, usesAdminConsoleOnly } = useAuth();

  const items = useMemo(() => {
    const raw = data?.data ?? [];
    return raw
      .filter((item) => {
        if (item.permission === 'authenticated') return isSignedIn;
        return true;
      })
      .map((item) => {
        const isDashboard = item.route === '/dashboard';
        const showAdminNav = isAdmin && !usesAdminConsoleOnly && isDashboard;
        return {
          id: item.id,
          label: showAdminNav ? 'Admin' : item.title,
          short: showAdminNav ? 'Admin' : item.shortTitle,
          path: showAdminNav ? '/admin' : item.route,
          iconName: showAdminNav ? 'LayoutDashboard' : item.icon,
          icon: resolveIcon(showAdminNav ? 'LayoutDashboard' : item.icon),
        };
      });
  }, [data, isSignedIn, isAdmin, usesAdminConsoleOnly]);

  return { items, isLoading };
}
